<nwx-unsupported-products
  [unsupportedProducts]="unsupportedProducts$ | async"
  [pcUrl]="pcURLLink$ | async"
></nwx-unsupported-products>
